<template>
  <div>
    <app-date/>
    <hr>
    <app-agence />
    <hr>
    <app-confreres/>
    <hr>
    <app-disponibilite/>
    <hr>
    <app-ajout-filtre/>
  </div>
</template>

<script>
import filtreDate from './date';
import AjoutFiltre from './ajoutFiltre';
import confreres from './confreres';
import Disponibilite from './disponibilite';
import Agence from './agence';

export default {
  name: 'filtres',
  components: {
    appDate: filtreDate,
    appAjoutFiltre: AjoutFiltre,
    appConfreres: confreres,
    appDisponibilite: Disponibilite,
    appAgence: Agence,
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/filtres/filtresPatrimoine.vue